import { createRootRoute, createRoute, Outlet } from "@tanstack/react-router";
import { OperatorPage } from "../features/operator/OperatorPage";

// The shift gate in <App> only mounts this router once an operator is on shift,
// so routes here don't re-check auth.
const rootRoute = createRootRoute({ component: Outlet });

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: OperatorPage,
});

const operatorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/new",
  component: OperatorPage,
});

export const routeTree = rootRoute.addChildren([indexRoute, operatorRoute]);
